<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--查找-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true" :model="filters" :rules="filtersRules" ref="filters">
          <el-form-item label="业务员姓名:" prop="name">
            <el-input v-model="filters.name" placeholder="业务员姓名" style="min-width: 120px"
              @keyup.enter.native="clickSearch('filters')"></el-input>
          </el-form-item>

          <el-form-item label="业务员工号:" prop="jobnumber">
            <el-input v-model="filters.jobnumber" placeholder="业务员工号" style="min-width: 100px"></el-input>
          </el-form-item>
              <el-form-item label="部门分组" prop="depgroupid">
                <el-select
                  v-model.trim="filters.depgroupid"
                  clearable
                  filterable
                  placeholder="请选择(可搜索)"
                >
                  <el-option
                    v-for="item in groupList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
         
        <el-form-item>
          <el-button type="primary" @click="clickSearch('filters')">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickUpload">文件上传</el-button>
        </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="showAddDialog">增加</el-button>
          </el-form-item> -->
          <el-form-item>
            <el-button @click="gotopage">重置</el-button>
          </el-form-item>

        </el-form>
      </el-col>
      <!--列表-->
      <el-table :data="mans" highlight-current-row v-loading="loading" border style="width: 100%">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="gname" label="部门分组" min-width="70"></el-table-column>  
        <el-table-column prop="jobnumber" label="工号" min-width="70"></el-table-column>
        <el-table-column prop="name" label="姓名" min-width="80"></el-table-column>
        <el-table-column prop="tyear" label="年份" min-width="80"></el-table-column>
        <el-table-column prop="tmonth" label="月份" min-width="80"></el-table-column>   
        <el-table-column prop="taskmoney" label="指标" min-width="170"></el-table-column>                        
        <el-table-column prop="updatetime" label="修改时间" min-width="140">
          <template slot-scope="scope">{{
            scope.row.updatetime | Time
          }}</template>
        </el-table-column>

        <!-- <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="showEditDialog(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <!--分页-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>
      <!-- 添加界面 -->
      <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="110px" :rules="addFormRules" ref="addForm" show-overflow-tooltip>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="部门分组" prop="depgroupid">
                <el-select
                  v-model.trim="addForm.depgroupid"
                  clearable
                  filterable
                  placeholder="请选择(可搜索)"
                >
                  <el-option
                    v-for="item in groupList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>            
          </el-row>
          <el-form-item label="业务员姓名" prop="name">
            <el-input v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="业务员工号" prop="jobnumber">
            <el-input v-model="addForm.jobnumber" auto-complete="off"></el-input>
          </el-form-item>          
          <el-form-item label="省份" prop="someprovince">
            <el-input v-model="addForm.someprovince" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="content">
            <el-input type="textarea" v-model="addForm.content"></el-input>
          </el-form-item>          
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交
          </el-button>
          <el-button @click.native="addFormVisible = false">取消</el-button>
        </div>
      </el-dialog>
      <!-- 编辑界面 -->
      <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="110px" :rules="editFormRules" ref="editForm" show-overflow-tooltip>
         <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="部门分组" prop="depgroupid">
                <el-select
                  v-model.trim="editForm.depgroupid"
                  clearable
                  filterable
                  placeholder="请选择(可搜索)"
                >
                  <el-option
                    v-for="item in groupList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>            
          </el-row>
          <el-form-item label="业务员姓名" prop="name">
            <el-input v-model="editForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="业务员工号" prop="jobnumber">
            <el-input v-model="editForm.jobnumber" auto-complete="off"></el-input>
          </el-form-item>          
          <el-form-item label="省份" prop="someprovince">
            <el-input v-model="editForm.someprovince" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="isdelete">
            <el-radio-group v-model="editForm.isdelete">
              <el-radio :label="0">启用</el-radio>
              <el-radio :label="1">删除</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注" prop="content">
            <el-input type="textarea" v-model="editForm.content"></el-input>
          </el-form-item>   


        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click.native="editSubmit" :loading="addLoading">提交
          </el-button>
          <el-button @click.native="editFormVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
import API from "../../../../api/frmonthtaskapi/taskkpi";
import APIGROUP from "../../../../api/frdepgroupapi/group";
export default {
  inject: ['reload'],
  data() {
    return {
      optionState: [
        {
          value: "0",
          label: "启用",
        },
        {
          value: "1",
          label: "删除",
        },        
      ],
      groupList: [],

      
      selectedOptions: [],

    
      addselectedOptions: [],

    
      editselectedOptions: [],

      filters: {
        name: "",
      },
      filtersRules: {
        mobile: [
          {
            required: true,
            message: "请输入正确的电话号码或者固话号码",
            trigger: "blur",
          },         
        ],
      },
      loading: false,
      mans: [],
      roles: [],
      roleIds: [],
      total: 0,
      page: 1,
      limit: 10,
     
      //新增相关数据
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [
          { required: true, message: "请输入业务员姓名", trigger: "blur" },
        ],
        jobnumber: [
          { required: true, message: "请输入业务员工号", trigger: "blur" },
        ],
        someprovince: [
          { required: true, message: "请输入管理省份", trigger: "blur" },
        ],

          depgroupid: [{ required: true, message: "请选择部门分组", trigger: "blur" }],

      },
      addForm: {
        shopname: "",
        
        info: "",
      },

      //编辑相关数据
      editFormVisible: false,
      editFormRules: {
        name: [{ required: true, message: "请输入会员姓名", trigger: "blur" }],

        jobnumber: [
          { required: true, message: "请输入业务员工号", trigger: "blur" },
        ],
        someprovince: [
          { required: true, message: "请输入管理省份", trigger: "blur" },
        ],

          depgroupid: [{ required: true, message: "请选择部门分组", trigger: "blur" }],
      },
      editForm: {
        shopname: "",
        
      },
    };
  },
  filters: {
    // 时间格式的转换
    Time(value) {
      if (typeof value === "undefined") {
        return;
      }

      var dateee = new Date(value).toJSON();
      var date = new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
      return date;
    },
  },
  methods: {
    clickUpload() 
    {
      this.$router.push("/sys/frsale/dailysales/uploadkpi");
    },
    gotopage() {
      //  this.$router.push('uploadsalemankpi?'+Math.random());
      this.reload();
    },
    formatIsdelete: function (row, column) {
      return row.isdelete == 0
        ? "启用"
        : row.isdelete == 1
          ? "删除"
          : "未知";
    },
    handleChange(value) {
      if (value != null && value != "") {
        this.selprovince = CodeToText[value[0]];
        if (value[1] != null && value[1] != "") {
          this.selcity = CodeToText[value[1]];
        }
        if (value[2] != null && value[2] != "") {
          this.selcountry = CodeToText[value[2]];
        }
      }
    },
    addhandleChange(value) {
      if (value != null && value != "") {
        this.addForm.province = CodeToText[value[0]];
        if (value[1] != null && value[1] != "") {
          this.addForm.city = CodeToText[value[1]];
        }
        if (value[2] != null && value[2] != "") {
          this.addForm.country = CodeToText[value[2]];
        }
      }
    },
    edithandleChange(value) {
      if (value != null && value != "") {
        this.editForm.province = CodeToText[value[0]];
        if (value[1] != null && value[1] != "") {
          this.editForm.city = CodeToText[value[1]];
        }
        if (value[2] != null && value[2] != "") {
          this.editForm.country = CodeToText[value[2]];
        }
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    handleSizeChange(val) {
      this.limit = val;
      this.search();
    },
    handleSearch() {
      this.total = 0;
      this.page = 1;
      this.search();      
    },
    //点击按钮查询
    clickSearch(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.total = 0;
          this.page = 1;
          this.filters.type = 1;
          this.search();
        }
      });
    },
    excelSearch(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.total = 0;
          this.page = 1;
          this.filters.type = 1;
          this.searchbyexcel();
        }
      });
    },
    clickAdd() {
      //
      this.$router.push("/sys/frbasicmember");
    },

        //分组下拉列表
    handlegroup() {
      let that = this;
      console.log('wa kaka2');
      APIGROUP.getDepgroup().then(function (result) {
        if (0 === result.code) {
          console.log('wa kaka3');
          that.groupList = result.data;        
        } else {
          that.$message.error({
            showClose: true,
            message: result.msg || "新增失败",
            duration: 2000,
          });
        }
      });
    },

    search: function () {
      let that = this;
      let params = {
        pageNum: that.page,
        pageSize: 10,
        name: that.filters.name,
        jobnumber: that.filters.jobnumber,    
        depgroupid: that.filters.depgroupid,    
      };

      that.loading = true;
      API.getPageList(params)
        .then(
          function (result) {
            that.loading = false;
            console.log(
              "哇卡卡走到这没" + JSON.stringify(result.data.totalSize)
            );
            if (result.data.totalSize == 0) {
              console.log("判断判断" + result.data.totalSize);
              that.mans = undefined;
            }
            if (result && result.data.totalSize) {
              that.total = result.data.totalSize;
              console.log(that.total + "--所有条数");
              that.mans = result.data.content;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },

    searchbyexcel: function () {
      let that = this;
      // console.log(this.value1.toString()+'---店原始时间哟');
      let datevaluestart = "";
      let datevalueend = "";
      if (this.value1.toString() == "") {
        console.log(this.value1.toString() + "---店没选时间哟");
      } else {
        console.log(this.value1.toString() + "---店已选时间哟");
        datevaluestart = this.dateFormat(this.value1.toString().split(",")[0]);
        datevalueend = this.dateFormat(this.value1.toString().split(",")[1]);
      }
      let params = {
        pageNum: that.page,
        pageSize: 10,
        shopname: that.filters.shopname,
        isdelete: that.filters.isdelete,
        province: this.selprovince,
        city: this.selcity,
        country: this.selcountry,
        email: that.filters.email,
        // value:
        //   this.dateFormat(this.value1.toString().split(",")[0]) +
        //   "," +
        //   this.dateFormat(this.value1.toString().split(",")[1]),
        datestart: datevaluestart,
        dateend: datevalueend,
        companyname: that.filters.companyname,
      };

      // that.loading = true;
      //{"pageNum":1,"pageSize":10,"province":"","city":"","country":"","datestart":"","dateend":""}
      // console.log('看看值是啥'+JSON.stringify(params));
      // const paramsinfo=[];
      // paramsinfo.push(JSON.stringify(params));
      let paramsurl = 'a=1';//没啥作用仅用于后面固定有个&符号，否则接收参数报错的
      if (params.shopname != null) {
        console.log(params.shopname);
        paramsurl += "&shopname=" + params.shopname;
      }
      if (params.isdelete != null) {
        paramsurl += "&isdelete=" + params.isdelete;
      }
      if (params.email != null) {
        paramsurl += "&email=" + params.email;
      }
      if (params.companyname != null) {
        paramsurl += "&companyname=" + params.companyname;
      }
      paramsurl += "&province=" + params.province;
      paramsurl += "&city=" + params.city;
      paramsurl += "&country=" + params.country;
      paramsurl += "&datestart=" + params.datestart;
      paramsurl += "&dateend=" + params.dateend;

      //console.log(params.province+'--');

      console.log(paramsurl + "&rnd=" + Math.random());
      location.href = "/api/shop/exportExcel?" + paramsurl;
    },

    showAddDialog: function (index, row) {
      let that = this;
      this.addFormVisible = true;
      this.addForm = Object.assign({}, row);
    },
    showEditDialog: function (index, row) {
      // console.log(JSON.stringify(row)+'--edit info ');
      let that = this;
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },

    dateFormat(dateData) {
      var date = new Date(dateData);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      const time = y + "-" + m + "-" + d;
      return time;
    },
    addSubmit: function () {
      let that = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.addForm);
          API.add(params).then(function (result) {
            that.loading = true;
            if (0 === result.code) {
              that.loading = false;
              that.$message;
              that.$message.success({
                showClose: true,
                message: "新增成功",
                duration: 2000,
              });
              that.$refs["addForm"].resetFields();
              that.addFormVisible = false;
              that.search();
            } else {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: result.message || "新增失败",
                duration: 2000,
              });
            }
          });
        }
      });
    },
    editSubmit: function () {
      let that = this;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, that.editForm);
          console.log("---修改操作罗-------" + JSON.stringify(params));
          API.update(params).then(function (result) {
            that.loading = true;
            if (0 === result.code) {
              that.loading = false;
              that.$message.success({
                showClose: true,
                message: "修改成功",
                duration: 2000,
              });
              that.$refs["editForm"].resetFields();
              that.editFormVisible = false;
              that.search();
            } else {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: result.message,
                duration: 2000,
              });
            }
          });
        }
      });
    },
    resetForm(formName) {
      // this[formName] = {};
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
    },
  },
  mounted() {
    this.handleSearch();
    this.handlegroup();
  },
};
</script>

<style scoped></style>
